<!-- src/app/pages/dashboard/components/statswidget.html -->
<div class="col-span-12 lg:col-span-6 xl:col-span-3">
  <div class="card mb-0 cursor-pointer" (click)="openDialogUploads('UploadedFilesWidget')">
    <!-- The widget shows the summary and handles fetching -->
    <app-uploaded-files-widget callerName="UploadedFilesWidget"></app-uploaded-files-widget>
  </div>
</div>

<div class="col-span-12 lg:col-span-6 xl:col-span-3">
  <div class="card mb-0 cursor-pointer" (click)="openDialogCreaded('UploadedFilesWidget')">
    <!-- The widget shows the summary and handles fetching -->
    <app-created-journals-widget callerName="UploadedJournalsWidget"></app-created-journals-widget>
  </div>
</div>

<div class="col-span-12 lg:col-span-6 xl:col-span-3">
  <div class="card mb-0 cursor-pointer" (click)="openDialogSuppliers('CreatedSuppliersWidget')">
    <!-- The widget shows the summary and handles fetching -->
    <app-created-suppliers-widget callerName="CreatedSuppliersWidget"></app-created-suppliers-widget>
  </div>
</div>

<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Inbox Messages</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">12 Unread</div>
            </div>
            <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-comment text-purple-500 !text-xl"></i>
            </div>
        </div>
        <span class="text-primary font-medium">29 </span>
        <span class="text-muted-color">responded</span>
    </div>
</div>